import React from 'react';
import { Navigation } from '../components/landing/Navigation';
import { HeroSection } from '../components/landing/HeroSection';
import { StatsMarquee } from '../components/landing/StatsMarquee';
import { TryItSection } from '../components/landing/TryItSection';
import { ResearchProofSection } from '../components/landing/ResearchProofSection';
import { DifferentiationSection } from '../components/landing/DifferentiationSection';
import { AdaptiveFlowSection } from '../components/landing/AdaptiveFlowSection';
import { PipelineSection } from '../components/landing/PipelineSection';
import { QuestionTypesSection } from '../components/landing/QuestionTypesSection';
import { CurriculumAlignmentSection } from '../components/landing/CurriculumAlignmentSection';
import { SubjectsGrid } from '../components/landing/SubjectsGrid';
import { HowItWorksSection } from '../components/landing/HowItWorksSection';
import { PortalsSection } from '../components/landing/PortalsSection';
import { EarlyAccessSection } from '../components/landing/EarlyAccessSection';
import { FAQSection } from '../components/landing/FAQSection';
import { FooterSection } from '../components/landing/FooterSection';
import { ParallaxOrbs } from '../components/landing/ParallaxOrbs';
import { ScrollProgress } from '../components/landing/ScrollProgress';
import { SectionDivider } from '../components/landing/SectionDivider';
import { MobileStickyCTA } from '../components/landing/MobileStickyCTA';
export function LandingPage() {
  return <div className="relative min-h-screen bg-[#FFF9F2] font-sans text-slate-900 selection:bg-orange-100 selection:text-orange-900 overflow-x-hidden" data-id="element-795">
      <ParallaxOrbs data-id="element-796" />
      <ScrollProgress data-id="element-797" />

      <Navigation data-id="element-798" />

      <main className="relative" data-id="element-799">
        <HeroSection data-id="element-800" />

        {/* Cream → donker */}
        <StatsMarquee data-id="element-801" />

        {/* Donker → cream (TryIt heeft eigen cream-achtergrond) */}
        <TryItSection data-id="element-802" />

        {/* cream → wit */}
        <SectionDivider from="#FFF9F2" to="#FFFFFF" variant="wave" data-id="element-803" />
        <ResearchProofSection data-id="element-804" />

        {/* wit → cream */}
        <SectionDivider from="#FFFFFF" to="#FFF9F2" variant="blob" flip data-id="element-805" />
        <DifferentiationSection data-id="element-806" />

        <AdaptiveFlowSection data-id="element-807" />

        {/* cream → wit (pipeline is wit / licht) */}
        <SectionDivider from="#FFF9F2" to="#FFFFFF" variant="wave" data-id="element-808" />
        <PipelineSection data-id="element-809" />

        {/* wit → cream */}
        <SectionDivider from="#FFFFFF" to="#FFF9F2" variant="blob" data-id="element-810" />
        <QuestionTypesSection data-id="element-811" />

        <CurriculumAlignmentSection data-id="element-812" />

        <SubjectsGrid data-id="element-813" />

        <HowItWorksSection data-id="element-814" />

        <PortalsSection data-id="element-815" />

        <SectionDivider from="#FFF9F2" to="#FFFFFF" variant="wave" data-id="element-816" />
        <EarlyAccessSection data-id="element-817" />

        <FAQSection data-id="element-818" />
      </main>

      <FooterSection data-id="element-819" />

      <MobileStickyCTA data-id="element-820" />
    </div>;
}